import { assert, isDefined } from '@sama/js-core';
import { ObjectState } from '../../../../../cross-team-shared/annotation/shared/state/object-state';
import {
  ObjectLocationOperationAttributes,
  UpsertObjectLocationOperation,
} from '../../../../../team-apis/otterdam/annotation-operations/object-operations';
import { ObjectLocationOperationBuilderParams } from './object-operation-builder-params';

export function createUpsertObjectLocationBuilders({
  locations,
  currentObject,
}: ObjectLocationOperationBuilderParams) {
  return locations.map(
    (location) =>
      new UpsertObjectLocationOperationBuilder(
        location.frameNumber,
        location.operationAttributes,
        currentObject,
      ),
  );
}

export class UpsertObjectLocationOperationBuilder {
  constructor(
    private frameNumber: number,
    private locationOperationAttributes?: ObjectLocationOperationAttributes,
    private objectState?: ObjectState,
  ) {}

  canBuild() {
    return (
      isDefined(this.objectState) && isDefined(this.locationOperationAttributes)
    );
  }

  build(): UpsertObjectLocationOperation {
    assert(
      this.locationOperationAttributes,
      'location operation attributes should be defined for upsert object location',
    );
    assert(
      this.objectState,
      'object should be defined for upsert object location',
    );

    const { tags, source } = this.locationOperationAttributes;
    return {
      operation: 'UPSERT_OBJECT_LOCATION',
      ids: { objectId: this.objectState.index, frameNumber: this.frameNumber },
      attributes: {
        tags,
        source,
      },
    };
  }
}
